export default Object.freeze({
  Header: 'header',
  Url: 'url',
  FormData: 'form-data',
  BodyJson: 'body-json',
  XWwwFormUrlEncoded: 'x-www-form-url-encoded',
  Authorization: 'authorization',
  BodyText: 'body-text',
  FormFileData: 'form-file-data',
});
